import { crudService } from '../_services/';
import alerts from '../_components/alerts';

export const logFazendaFinanceiroSincAction = {
    getLogFazendaFinanceiroSinc
};

function getLogFazendaFinanceiroSinc() {
    return dispatch => {
        alerts.waiting();
        let apiEndpoint = 'log/financeiro';
        crudService.get(apiEndpoint)
            .then((response) => {
                dispatch(changeLogsList(response.data));
                alerts.clean();
            })
    };
}

export function changeLogsList(logFazendaFinanceiroSinc) {
    return {
        type: "FETECHED_ALL_LOG_FAZENDA_FINANCEIRO_SINC",
        logFazendaFinanceiroSinc: logFazendaFinanceiroSinc
    }
}